import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserData, login, logout } from '../app/slices/authSlice';
import {useEffect} from "react";

export function useAuth() {
    const { auth } = useSelector(state => ({
        auth: state.auth
    }));
    const [authenticated, setAuthenticated] = React.useState(auth.authenticated);
    const [userData, setUserData] = React.useState(auth.userData);
    const [isAdmin, setIsAdmin] = React.useState(auth.userData?.roles.includes("Administrator"));
    const dispatch = useDispatch();

    useEffect(() => {
        setIsAdmin(auth.userData?.roles.includes("Administrator"));
    }, [auth.userData?.roles]);

    React.useEffect(() => {
        dispatch(getUserData()).then((result) => {
            if (result.payload) {
                setAuthenticated(true);
                setUserData(result.payload);
            }
        });
    }, [dispatch]);

    return {
        isAdmin,
        authenticated,
        userData,
        login(credentials) {
            return new Promise(async (res) => {
                let loginResult = await dispatch(login(credentials));

                if (loginResult.payload.hasOwnProperty('refresh_token')) {
                    let userData = await dispatch(getUserData());

                    setAuthenticated(true);
                    setUserData(userData.payload);
                }
                res();
            });
        },
        logout() {
            return new Promise((res) => {
                dispatch(logout()).then(() => {
                    setAuthenticated(false);
                });
                res();
            });
        },
    };
}